<div class="card-container" [style.backgroundColor]="courseCardInfo.color">
  <div class="card-format" [style.height.px]="cardSizeScaled">
    <div class="card-content-container" fxLayout="column" [style.transform]="scaleCard" (click)="goToInfo()">
      <div class="card-date">{{ courseCardInfo.date }}</div>
      <div class="card-title" [matTooltip]="courseCardInfo.name">
        <a [routerLink]="['course-info/', courseCardInfo.id]"> <!-- "['./../lessons/course/', courseCardInfo.id]" -->
          <div>{{ courseCardInfo.name }}</div>
        </a>
      </div>
      <!-- <mat-chip-list class="card-tag-container">
        <mat-chip class="card-tag" *ngFor="let tag of courseCardInfo.tags" [style.color]="courseCardInfo.color">
          {{ tag }}
        </mat-chip>
      </mat-chip-list> -->
      <div class="card-category">{{ courseCardInfo.category }}</div>
      <div fxFlex></div>
      <!-- <div class="card-age" fxLayout="row" fxLayoutAlign="left center" fxLayoutGap="1em">
        <div>
          <mat-icon>people_outline</mat-icon>
        </div>
         <div>
          {{ profilesCount }}
        </div> 
      </div> -->
    </div>
    <div fxFlex></div>
    <div class="buttons-container" fxLayout="column" [style.transform]="scaleCard">
      <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button" *ngIf="showActionButton()">
        <mat-icon [matMenuTriggerFor]="menu">more_horiz</mat-icon>
        <mat-menu #menu="matMenu" [style.transform]="scaleCard">
          <button mat-menu-item (click)="onEdit()" class="card-menu"><small>{{'MENU_CARD.EDIT'|translate}}</small></button>
          <mat-divider></mat-divider>
          <!-- <button mat-menu-item (click)="onDeactivate()" class="card-menu">
            <small>{{courseCardInfo.isPublic ? 'Desactivar':'Activar'}}</small>
          </button>
          <mat-divider></mat-divider> -->
          <button mat-menu-item (click)="onDelete()" class="card-menu"><small>{{'MENU_CARD.DELETE'|translate}}</small></button>
        </mat-menu>
      </div>
      <div fxFlex  (click)="goToInfo()"></div>
      <!-- <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button">
        <mat-icon>smartphone</mat-icon>
      </div> -->
      <!-- <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button">
        <mat-icon (click)="onDeactivate()" matTooltip="{{courseCardInfo.isPublic ? 'Publica':'Privada'}}">
          {{courseCardInfo.isPublic ? 'visibility':'visibility_off'}}
        </mat-icon>
      </div> -->
    </div>
  </div>
</div>
